import { GlobalStore } from "../../../../store/global/GlobalStore";
import { Theme } from "../../../../styles/theme";
import { AddIcon, CheckmarkIcon } from "../../../Icons";
import { AddTokenButtonContainer } from "./elements/AddTokenButtonContainer";

export enum AddTokenButtonState {
  default,
  hover,
  selected,
  disabled,
  unavailable,
}

interface AddTokenButtonProps {
  state: AddTokenButtonState;
}

export const AddTokenButton = ({ state }: AddTokenButtonProps) => {
  const theme = GlobalStore.useState(s => s.theme);
  const backgroundColor = getBackgroundColor(state, theme);
  const strokeColor = getStrokeColor(state, theme);

  return (
    <AddTokenButtonContainer
      isVisible={state !== AddTokenButtonState.unavailable}
      backgroundColor={backgroundColor}
    >
      {state === AddTokenButtonState.selected ? (
        <CheckmarkIcon color={strokeColor} width={24} height={24} />
      ) : (
        <AddIcon color={strokeColor} width={24} height={24} />
      )}
    </AddTokenButtonContainer>
  );
};

// Helpers

function getBackgroundColor(state: AddTokenButtonState, theme: Theme) {
  switch (state) {
    case AddTokenButtonState.selected:
      return theme["Colour ramps"].Green[700];
    case AddTokenButtonState.hover:
      return theme.button.tertiary.surface.active;
    case AddTokenButtonState.disabled:
      return "#334545"; // not in JSON theme files
    default:
      return theme["Dark mode"][600];
  }
}

function getStrokeColor(state: AddTokenButtonState, theme: Theme) {
  switch (state) {
    case AddTokenButtonState.selected:
      return theme["Dark mode"][2000];
    case AddTokenButtonState.disabled:
      return "#808B8B"; // not in JSON theme files
    case AddTokenButtonState.hover:
    default:
      return theme["Colour ramps"].Green[500];
  }
}
